// @ts-strict-ignore
import React from 'react'
import { DeleteButton, DeleteIcon } from './styles'
import { useFilePreview } from './provider'
import I18n from 'APP/I18n'

/**
 * FileActions component renders action buttons for file preview.
 * @returns {JSX.Element} The rendered action buttons for the file preview.
 */
function FileActions() {
  const { onDelete, file } = useFilePreview()
  return (
    <>
      {onDelete && (
        <DeleteButton
          onPress={() => onDelete(file)}
          accessibilityLabel={`${I18n.t('FilePreview.delete')} ${file?.name}`}
          accessibilityRole="button"
          testID="DELETE_BUTTON"
        >
          <DeleteIcon src="trash-can-outline" variant="material" size={20} />
        </DeleteButton>
      )}
    </>
  )
}

export default FileActions
